import { useLocation, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import './Home.scss';
import HomeView from '../../constants/HomeView';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import SVLS_API from '../../svls-api';
import { BRAND_DOMAIN } from '../../constants/Branding';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { getCurrencyTypeFromToken } from '../../store';
import { AuthResponse } from '../../models/api/AuthResponse';
import { DomainConfig } from '../../models/DomainConfig';

const WebBanners = HomeView.HOME_PAGE_WEB_BANNERS;
const MobBanners = HomeView.HOME_PAGE_MOB_BANNERS;


type StoreProps = {
    allowedConfig: number;
    loggedIn: boolean;
    loggedInUserStatus: any;
    domainConfig: DomainConfig;
};

const Banner: React.FC<StoreProps> = (props) => {
    const history = useHistory();
    const { allowedConfig, loggedIn, loggedInUserStatus, domainConfig } = props;
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [adminWhatsAppNumber, setAdminWhatsAppNumber] = useState<string>();
    const [apiWebBanners, setApiWebBanners] = useState([]);
    const [apiMobBanners, setApiMobBanners] = useState([]);
    const pathLocation = useLocation();

    const setDialogShow = (show: boolean) => {
        setShowDialog(show);
    };

    const getAdminWhatsAppNumber = async () => {
        try {
            const response = await SVLS_API.get(`/account/v2/books/${BRAND_DOMAIN}`, {});
            if (response.status === 200) {
                setAdminWhatsAppNumber(response?.data?.contact?.whatsappNumber);
            }
        } catch (err) { }
    };

    useEffect(() => {
        if (domainConfig.whatsapp) {
            getAdminWhatsAppNumber();
        }
    }, []);

    const getBanners = (device: 'mobile' | 'web') => {
        if (device === 'mobile') {
          if(apiMobBanners.length >0){
            return apiMobBanners;
          }else {
            return MobBanners.filter(
              (m) => (m.configPermission & allowedConfig) !== 0
            );
          }
        } else {
          if(apiWebBanners.length >0){
              return apiWebBanners;
          }else {
            return WebBanners.filter(
              (m) => (m.configPermission & allowedConfig) !== 0
            );
          }
          
        }
      };
    const navigateToLink = (data) => {
    if(data?.redirectionUrl =='/exchange_sports/inplay' || data?.redirectionUrl =='/casino' || data?.redirectionUrl =='/exchange_sports/cricket' || data?.redirectionUrl =='/exchange_sports/tennis' || data?.redirectionUrl =='/exchange_sports/football'){
      history.push(data?.redirectionUrl);
    }else if(data?.redirectionUrl == 'nourl'){
    }else if(data.url){
      if (data.url.includes('/casino')) {
        if (ALLOW_CASINO) history.push(data.url);
      } else {
        history.push(data.url);
      }
    }
    else {
      let url = data?.redirectionUrl;
      window.open(url,'_blank');
    }
  };
  useEffect(() => {
    fetchBannerData();
  }, []);


    const fetchBannerData = async () => {
        try {
          const response: AuthResponse = await SVLS_API.get(
            `/account/v2/books/${BRAND_DOMAIN}/banners`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              params: {
                status: 'active',
                type: '*',
                category:'homebanner'
              },
            }
          );
          let data = response?.data?.banners;
          let webdata = [];
          let mobiledata = [];
          if(data?.length > 0){
          data.map(item=> {
            if(item.deviceType === "desktop"){
              webdata.push(item);
            }else if(item.deviceType === "mobile"){
              mobiledata.push(item)
            }
          })
          setApiWebBanners(webdata);
          setApiMobBanners(mobiledata);
        }
        } catch (err) {
          console.log(err)
          //setShowError(true);
          if (err.response && err.response.status === 400) {
            //setErrorText(err.response.data.message);
          } else {
            //setErrorText('Something went wrong');
          }
        }
        
      };
    
    const getGameUrl = async (
        gameId: string,
        gameName: string,
        gameCode: string,
        provider: string,
        subProvider: string
    ) => {
        if (loggedIn) {
            // status check
            if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
                history.push(`/home`);
            }
            if (provider === 'Indian Casino') {
                // setCasinoGame({ id: gameCode, name: gameName });
                history.push(`/casino/indian/${gameCode}`);
            } else {
                history.push(
                    `/dc/gamev1.1/${gameName?.toLowerCase().replace(/\s+/g, '-')}-${btoa(
                        gameId?.toString()
                    )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
                );
            }
        } else {
            setDialogShow(true);
        }
    };

    const handleGameClick = async (
        gameId: string,
        gameName: string,
        gameCode: string,
        subProvider: string,
        provider?: string
    ) => {
        if (
            getCurrencyTypeFromToken() === 0 &&
            !(
                provider?.toLocaleLowerCase() === 'ezugi' ||
                subProvider === 'BetGames.TV' ||
                subProvider === 'Pragmatic Play' ||
                subProvider === 'Onetouch Live' ||
                subProvider === 'OneTouch' ||
                provider === 'RG'
            )
        ) {
            getGameUrl(gameId, gameName, gameCode, provider, subProvider);
            // setSelectedEvolutionGame({
            //   gameId,
            //   gameName,
            //   gameCode,
            //   provider,
            //   subProvider,
            // });
            // setInfoDialog(true);
        } else {
            getGameUrl(gameId, gameName, gameCode, provider, subProvider);
        }
    };

    return (
        <>
            <Carousel
                className="web-banners"
                autoPlay={true}
                infiniteLoop={true}
                interval={5000}
                showThumbs={false}
                showStatus={false}
            >
                {getBanners('web').map((banner) => (
                    <div key={banner?.text + 'container'}>
                        <img loading="lazy"
                            onClick={() => {
                                if (banner?.text === "Aviator" && !loggedIn) {
                                    handleGameClick(
                                        '201206',
                                        'AVIATOR',
                                        'sbe_aviator',
                                        'Spribe',
                                        'DC'
                                    )
                                }
                                else if (banner?.publicUrl.includes('faircric-banner1') || banner?.publicUrl.includes('faircric-banner2')) {
                                    window.location.href = `http://api.whatsapp.com/send?phone=${adminWhatsAppNumber}`
                                } else {
                                    navigateToLink(banner)
                                }
                            }}
                            className="banner-images"
                            src={banner?.publicUrl}
                            key={banner?.text + 'image'}
                            alt={banner?.text}
                            title={banner?.text}
                        />
                    </div>
                ))}
            </Carousel>

            <Carousel
                className="mob-banners"
                autoPlay={true}
                infiniteLoop={true}
                interval={5000}
                showThumbs={false}
                showStatus={false}
            >
                {getBanners('mobile').map((banner) => (
                    <div key={banner.text + 'container'}>
                        <img loading="lazy"
                            onClick={() => {
                                if (banner.text === "Aviator" && !loggedIn) {
                                    handleGameClick(
                                        '201206',
                                        'AVIATOR',
                                        'sbe_aviator',
                                        'Spribe',
                                        'DC'
                                    )
                                } else if (banner.publicUrl.includes('faircric-+mob_banner1') ||
                                    banner.publicUrl.includes('faircric-mob_banner1') ||
                                    banner.publicUrl.includes('faircric-+mob_banner2') ||
                                    banner.publicUrl.includes('faircric-mob_banner2')) {
                                    window.location.href = `http://api.whatsapp.com/send?phone=${adminWhatsAppNumber}`
                                } else {
                                    navigateToLink(banner)
                                }
                            }}
                            className="banner-images"
                            src={banner.publicUrl}
                            key={banner.text + 'image'}
                            alt={banner.text}
                            title={banner.text}
                        />
                    </div>
                ))}
            </Carousel>
            <Dialog
                open={showDialog}
                onClose={() => setDialogShow(false)}
                aria-labelledby="form-dialog-title"
                maxWidth="xs"
            >
                <DialogTitle id="form-dialog-title">Notice</DialogTitle>
                <DialogContent>
                    <div className="dc-dialog-body">
                        You have to be logged in to play
                    </div>
                </DialogContent>
                <DialogActions className="dc-dialog-actions">
                    <Button
                        onClick={() => setDialogShow(false)}
                        color="primary"
                        autoFocus
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    let status = 0;
    if (state.auth.loggedIn) {
        status = JSON.parse(
            window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
        ).status;
    }
    return {
        loggedIn: state.auth.loggedIn,
        loggedInUserStatus: status,
        domainConfig: state.common.domainConfig
    };
};

export default connect(mapStateToProps, null)(Banner);

